import * as React from 'react';
import { useState, useEffect } from 'react';
import classNames from 'classnames';
import KeyCode from 'rc-util/lib/KeyCode';
import Popover from '../../../popover';
function TabNode({ prefixCls, id, active, rtl, tab: { key, tab, disabled, closeIcon, max }, tabBarGutter, tabPosition, closable, renderWrapper, removeAriaLabel, editable, onClick, onRemove, onFocus, onEditTabNav }, ref) {
    const tabPrefix = `${prefixCls}-tab`;
    const [isEditNav, setEditNav] = useState(false);
    const [editTab, setEditTab] = useState();
    React.useEffect(() => onRemove, []);
    const nodeStyle = {};
    if (tabPosition === 'top' || tabPosition === 'bottom') {
        nodeStyle[rtl ? 'marginRight' : 'marginLeft'] = tabBarGutter;
    }
    else {
        nodeStyle.marginTop = tabBarGutter;
    }
    const removable = editable && closable !== false && !disabled;
    function getLenPx(str) {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = '400 12px arial';
        const result = context.measureText(str);
        return result.width;
    }
    ;
    function onInternalClick(e) {
        if (disabled)
            return;
        onClick(e);
    }
    function onRemoveTab(event) {
        event.preventDefault();
        event.stopPropagation();
        editable.onEdit('remove', {
            key,
            event
        });
    }
    function onDoubleClick() {
        if (editable && editable.showEdit && typeof tab !== 'object') {
            setEditNav(true);
        }
    }
    function onChange(e) {
        setEditTab(e.target.value);
    }
    function onBlur() {
        onEditTabNav && onEditTabNav(editTab || tab.toString());
        setEditNav(false);
    }
    function onKeyDown(e) {
        let keyCode = null;
        if (e.which) {
            keyCode = e.which;
        }
        else if (e.keyCode) {
            keyCode = e.keyCode;
        }
        if (keyCode === 13) {
            onEditTabNav && onEditTabNav(editTab || tab.toString());
            setEditNav(false);
        }
    }
    useEffect(() => {
        if (typeof tab !== 'object') {
            setEditTab(tab.toString());
        }
    }, [tab]);
    useEffect(() => {
        if (isEditNav) {
            const tabNode = document.getElementsByClassName(`${tabPrefix}-btn`)[0];
            const width = tabNode.clientWidth;
            const contentWidth = getLenPx(editTab);
            const inputNode = document.getElementsByClassName(`${tabPrefix}-btn-edit`)[0];
            if (inputNode && inputNode instanceof HTMLElement) {
                if (width) {
                    inputNode.style.width = `${width}px`;
                    inputNode.scrollLeft = contentWidth - width > 0 ? contentWidth - width : 0;
                }
                inputNode.focus();
            }
        }
    }, [isEditNav]);
    let node = (<Popover content={tab} overlayStyle={{ display: max && tab.toString().length > max ? '' : 'none' }} placement='topLeft'>
            <div key={key} ref={ref} className={classNames(tabPrefix, {
            [`${tabPrefix}-with-remove`]: removable,
            [`${tabPrefix}-active`]: active,
            [`${tabPrefix}-disabled`]: disabled,
        })} style={nodeStyle} onClick={onInternalClick} onDoubleClick={onDoubleClick}>
                {/* Primary Tab Button */}
                <div role="tab" aria-selected={active} id={id && `${id}-tab-${key}`} className={`${tabPrefix}-btn`} aria-controls={id && `${id}-panel-${key}`} aria-disabled={disabled} tabIndex={disabled ? null : 0} onClick={e => {
            e.stopPropagation();
            onInternalClick(e);
        }} onKeyDown={e => {
            if ([KeyCode.SPACE, KeyCode.ENTER].includes(e.which)) {
                e.preventDefault();
                onInternalClick(e);
            }
        }} onFocus={onFocus}>
                    {!isEditNav && (max && tab.toString().length > max ? tab.toString().substring(0, max) + '...' : tab)}
                    {isEditNav && <input className={`${tabPrefix}-btn-edit`} value={editTab} onChange={onChange} onBlur={onBlur} onKeyDown={onKeyDown}/>}
                </div>

                {/* Remove Button */}
                {removable && !isEditNav && (<button type="button" aria-label={removeAriaLabel || 'remove'} tabIndex={0} className={`${tabPrefix}-remove`} onClick={e => {
                e.stopPropagation();
                onRemoveTab(e);
            }}>
                        {closeIcon || editable.removeIcon || '×'}
                    </button>)}
            </div>
        </Popover>);
    if (renderWrapper) {
        node = renderWrapper(node);
    }
    return node;
}
export default React.forwardRef(TabNode);
